import { render, staticRenderFns } from "./barMul.vue?vue&type=template&id=237fd278&"
import script from "./barMul.vue?vue&type=script&lang=js&"
export * from "./barMul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "barMul.vue"
export default component.exports